/* eslint-disable indent */

import i18next from 'i18next';
import { getDefaultAccess } from '../utils/defaultAccess';
import { takeCorrectBundle } from '../utils/bundle';
import { useQueryClient } from '@tanstack/react-query';
import { useHospitalStore } from '../stores/useHospitalStore';

/**
 * @function useBundles - used to return the correct bundle
 * bundle Basic = 5
 * bundle Standard = 6
 * bundle Pharmacy = 7
 * @param bundle
 * @returns if has the correct bundle
 */
export const useBundles = (bundle: number) => {
    const defaultAccess = getDefaultAccess();
    const { hospitalInfo } = useHospitalStore((state) => state);

    const tenantId = hospitalInfo?.TenantId || defaultAccess?.tenantId;
    const networkId = hospitalInfo?.NetworkId || defaultAccess?.networkId;
    const hospitalId = hospitalInfo?.HospitalId || defaultAccess?.hospitalId;

    const bundleKey = ['userBundles', i18next.language, tenantId, networkId, hospitalId];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const userBundles: any = useQueryClient().getQueryData(bundleKey);

    return !!takeCorrectBundle(userBundles, bundle);
};